import { Link } from "react-router-dom"
import DashboardSideBar from "../../components/dashboardSidebar"
import Footer from "../../components/footer"
import Header from "../../components/header"
import SideBar from "../../components/sidebar"
import services from "../../services"
import { useEffect, useState } from "react"
import moment from "moment"
import { Rating } from 'react-simple-star-rating'
import useIsMobile from "../../hooks/useIsMobile";
import MobileFooter from "../../components/MobileFooter";
import MobileHeader from "../../components/MobileHeader";
const MyRatings = () => {
    const isMobileView = useIsMobile()
    const [bookingList, setBookingList] = useState([])
    useEffect(() => {
        getBookingsHandler();
    }, [])
    const getBookingsHandler = async () => {
        try {
            const response = await services.order.BOOKING_LISTING();

            let data = response.data;
            if (data.length) {
                data.map((item) => {
                    item.BookingDetails.sort(function (a, b) {
                        return parseFloat(a.id) - parseFloat(b.id);
                    });
                })
                var newArray = data.filter(function (el) {
                    return el.BookingDetails[0].bookingStatus == 'ended';
                });
                console.log(newArray)
                setBookingList(newArray)
            }
        } catch (error) {
            console.log(error)
        }
    }
    if (isMobileView) {
        const reviewed = (bookingList || []).filter((b) => b.BookingReviews?.[0]);
        const avg = reviewed.length ? (reviewed.reduce((s, b) => s + (b.BookingReviews[0].rating || 0), 0) / reviewed.length) : 0;
        return (
            <>
                <SideBar />
                <main className="mlux">
                    <MobileHeader right={<Link to="/" className="mlux-avatar"><i className="fas fa-gauge-high"></i></Link>} />
                    <div className="mlux-greet" style={{ margin: '8px 4px 2px' }} data-rise="1">
                        <div className="kick">Rider feedback</div>
                        <div className="nm" style={{ fontSize: 24 }}>Ratings</div>
                    </div>

                    {reviewed.length > 0 && (
                        <div className="mlux-card" style={{ padding: 18, textAlign: 'center' }} data-rise="2">
                            <div style={{ fontSize: 40, fontWeight: 800, letterSpacing: '-0.03em', lineHeight: 1 }}>{avg.toFixed(1)}</div>
                            <div className="mlux-review-stars"><Rating readonly initialValue={avg} size={24} allowFraction /></div>
                            <div className="ls" style={{ textAlign: 'center' }}>{reviewed.length} review{reviewed.length === 1 ? '' : 's'}</div>
                        </div>
                    )}

                    <div className="mlux-sec-head"><h3>Reviews</h3></div>
                    {reviewed.length ? reviewed.map((item) => (
                        <div className="mlux-card mlux-review-row" key={item.id} data-rise="3">
                            <div className="rtop">
                                <div className="rcar">{item.Car?.brand} {item.Car?.name} · #{item.id}</div>
                                <Rating readonly initialValue={item.BookingReviews[0].rating} size={16} allowFraction />
                            </div>
                            <div className="rroute">{item?.BookingDetails?.[0]?.pickupLocation?.addressLine} → {item?.BookingDetails?.[0]?.dropLocation?.addressLine}</div>
                            {item.BookingReviews[0].comment && <div className="rcomment">“{item.BookingReviews[0].comment}”</div>}
                        </div>
                    )) : (
                        <div className="mlux-card mlux-empty" data-rise="3">
                            <div className="ic"><i className="far fa-star"></i></div>
                            <h4>No reviews yet</h4>
                            <p>Ratings from your riders will appear here.</p>
                        </div>
                    )}
                </main>
                <MobileFooter />
            </>
        );
    }

    return (<>
        <Header />
        <SideBar />
        <main class="main">




            <div class="user-profile py-5">
                <div class="container">
                    <div class="row">
                        <DashboardSideBar />
                        <div class="col-lg-9">
                            <div class="user-profile-wrapper">
                                <div class="row">
                                    <div class="col-lg-12">
                                        <div class="user-profile-card">
                                            <div class="user-profile-card-header">
                                                <h4 class="user-profile-card-title">My Booking Reviews</h4>
                                                <div class="user-profile-card-header-right">
                                                    <div class="user-profile-search">
                                                        <div class="form-group">
                                                            <input type="text" class="form-control" placeholder="Search..." />
                                                            <i class="far fa-search"></i>
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                            <div class="table-responsive">
                                                <table class="table text-nowrap">
                                                    <thead>
                                                        <tr>
                                                            <th className="">Cab Info</th>
                                                            
                                                            <th>Pickup and drop</th>
                                                            <th>Rating</th>
                                                            <th>Review</th>
                                                            <th>Action</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {bookingList?.map((item) => {
                                                            return (<tr key={item.id}>
                                                                <td>
                                                                    <div class="table-list-info">
                                                                        <a href="#">
                                                                            {/* <img src="/assets/img/taxi/01.png" alt/> */}
                                                                            <div class="table-list-content">
                                                                                <h6>{item.Car.brand} {item.Car.name}</h6>
                                                                                <span>Booking ID: #{item.id}</span>
                                                                            </div>
                                                                        </a>
                                                                    </div>
                                                                </td>
                                                               
                                                                <td>
                                                                    <span>{item?.BookingDetails[0].pickupLocation.addressLine}</span> <br />
                                                                    <span>{item?.BookingDetails[0].dropLocation.addressLine}</span>
                                                                    {/* <p>03:15 PM</p> */}
                                                                </td>
                                                                <td><Rating
                                                                    initialValue={item.BookingReviews[0]?.rating}
                                                                /></td>
                                                                <td>{item.BookingReviews[0]?.comment}</td>
                                                                <td>
                                                                    <Link to={`/booking/${item.id}`}
                                                                        class="btn btn-outline-secondary btn-sm rounded-2"
                                                                        data-bs-toggle="tooltip" title="Details"><i
                                                                            class="far fa-eye"></i></Link>
                                                                </td>
                                                            </tr>)
                                                        })}

                                                    </tbody>
                                                </table>
                                            </div>

                                            <div class="pagination-area d-none">
                                                <div aria-label="Page navigation example">
                                                    <ul class="pagination my-3">
                                                        <li class="page-item">
                                                            <a class="page-link" href="#" aria-label="Previous">
                                                                <span aria-hidden="true"><i
                                                                    class="far fa-angle-double-left"></i></span>
                                                            </a>
                                                        </li>
                                                        <li class="page-item active"><a class="page-link" href="#">1</a>
                                                        </li>
                                                        <li class="page-item"><a class="page-link" href="#">2</a></li>
                                                        <li class="page-item"><a class="page-link" href="#">3</a></li>
                                                        <li class="page-item">
                                                            <a class="page-link" href="#" aria-label="Next">
                                                                <span aria-hidden="true"><i
                                                                    class="far fa-angle-double-right"></i></span>
                                                            </a>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </main>
        <Footer />
    </>
    )
}
export default MyRatings